module.exports = __webpack_public_path__ + "img/ring_y_l_1_null@2x.aa3c0ce4.png";